import { calculateLocatinVars } from '../../../libs/browser';
import { formatDate } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import IconBenefitsRed from '../../../assets/hkdc/icons/BenefitsRedIcon';
import QRCode from 'react-qr-code';
import React, { useContext, useEffect, useRef, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

// 假设容器宽度为0.5rem
const CONTAINER_WIDTH = 0.5;

export default function MobileVoucherDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const nationRef = useRef(null);

  const notificationNotReadCount = useNotificationsCount();

  const { init, me, dispatch, lang } = useContext(Context);

  const [data, setData] = useState(null);
  const [vouchersData, setVouchersData] = useState([]);

  const getItem = async (page) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getItems({
        page,
        pageSize: 1000,
        status: 'available'
      });
      setVouchersData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);

      const couponIndex = response.list.findIndex((i) => i.token === location.state?.data);
      if (couponIndex >= 0) {
        setData({ token: response.list[couponIndex].token, index : couponIndex });

      }

    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) {
      getItem(1);
    }
  }, [init, me, navigate]);

  const maxVisibleDots = 18; // 在容器中最多可见的圆点数量
  const visibleDots = Math.min(maxVisibleDots, vouchersData.length);

  return (
    (
      <div className='mobile-voucher-detail-page'>
        <BackCloseBarComponent />
        {
          data &&
          <div className="content-container">
              {
                vouchersData.length > 0 && vouchersData.map((item, index) => {
                  return (
                    <div key={index} className='info-container' style={{ display: item.token !== data.token ? 'none' : undefined }}>
                      <div className="title-icon-cont">
                        <div className="icon-container">
                          <IconBenefitsRed
                            className="icon"
                            size="large" />
                        </div>
                        <div className="title">
                          {item?.title?.[lang]}
                        </div>
                      </div>
                      <div className="qr-container">
                        <div className="qr-img-cont">
                          <QRCode className='qrcode' size={256} value={item?.token} />
                          <div className="id-container">
                            {`ID: ${item?.token}`}
                          </div>
                        </div>
                        <div className="time-text">
                          {`${t('vouchers.expiry')}${formatDate(item?.expire_at, lang)}`}
                        </div>
                      </div>
                      <div className="desc-text-container">
                        <div className="top-text-container">
                          <div className="title">
                            {`${t('vouchers.applicable')}`}
                          </div>
                          <div className="text">
                            {item?.stores?.length > 0 ? `${item?.stores.reduce((acc, val, index, arr) => {
                              return acc += `${val?.title?.[lang]}${index === arr.length - 1 ? '' : ', '}`;
                            }, '')}.` : ''}
                          </div>
                        </div>
                        <div className="bottom-text-container">
                          <div className="title">
                            {`${t('vouchers.description')}`}
                          </div>
                          <div className="text">
                            { item?.details?.[lang] &&
                              <CommonDescription data={item?.details?.[lang]} />
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            {/* <div className="info-nation-container">
              <div ref={nationRef} className="info-nation">
                {
                  vouchersData.length > 0 && vouchersData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`nation-item${data.token === item.token ? ' active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (data === item.token) return;
                          if (nationRef.current && nationRef.current.children && nationRef.current.children[index]) {
                            nationRef.current.scrollTo({
                              top: 0,
                              left: nationRef.current.children[index].offsetLeft - 150,
                              behavior: 'smooth'
                            });
                          }
                          setData({ token: item.token, index: index });
                        }}
                      />
                    );
                  })
                }
              </div>
              <div className="nation-text">
                {`${vouchersData.findIndex((item) => item.token === data.token) + 1}/${vouchersData.length}`}
              </div>
            </div> */}
          </div>
        }

        <div className="block-footer">
          <div className="block-1 red-block" />
          <div className="block-2" />
        </div>
      </div>
    )
  );
}